<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chap-title">Dedication</h1>
<p class="dedic">As ever, this one is for you, Dad. I miss you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?3d3f1996